module.exports = __webpack_public_path__ + "img/ns.adf9d780.png";